export default __webpack_public_path__ + "static/media/bg_form.8673c095.png";